import bannerImg from './banners/woman-helping-man-gym.jpg';

const evolucaoSemanalTreino = (t) => ({
    id: 'evolucao-semanal-treino',
    title: t('templates.items.evolucaoSemanalTreino.title'),
    description: t('templates.items.evolucaoSemanalTreino.description'),
    indicatedFor: t('templates.audiences.personalTrainers'),
    stepsCount: 1,
    questionsSummary: [
        t('templates.items.evolucaoSemanalTreino.summary.workoutsDone'),
        t('templates.items.evolucaoSemanalTreino.summary.sleepQuality'),
        t('templates.items.evolucaoSemanalTreino.summary.energyLevel'),
        t('templates.items.evolucaoSemanalTreino.summary.generalFeedback'),
    ],
    banner: `url(${bannerImg}) center / cover no-repeat`,
    formData: {
        title: t('templates.items.evolucaoSemanalTreino.form.title'),
        active: false,
        allow_multiple_answers: true,
        theme: 'light',
        steps: [
            {
                order: 1,
                title: t('templates.items.evolucaoSemanalTreino.form.week.title'),
                description: null,
                header: null,
                submitAction: 'next_step',
                submitButtonText: t('templates.items.evolucaoSemanalTreino.form.week.submit'),
                allowReturn: false,
                submitLink: null,
                questions: [
                    {
                        order: 1,
                        type: 'number',
                        label: t('templates.items.evolucaoSemanalTreino.form.week.workoutsDone.label'),
                        description: null,
                        required: true,
                        settings: null,
                    },
                    {
                        order: 2,
                        type: 'scale',
                        label: t('templates.items.evolucaoSemanalTreino.form.week.sleepQuality.label'),
                        description: null,
                        required: true,
                        settings: {
                            min: 1,
                            max: 5,
                            minLabel: t('templates.items.evolucaoSemanalTreino.form.week.sleepQuality.minLabel'),
                            maxLabel: t('templates.items.evolucaoSemanalTreino.form.week.sleepQuality.maxLabel'),
                            dotConfigs: [
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                            ],
                        },
                    },
                    {
                        order: 3,
                        type: 'scale',
                        label: t('templates.items.evolucaoSemanalTreino.form.week.energyLevel.label'),
                        description: null,
                        required: true,
                        settings: {
                            min: 1,
                            max: 5,
                            minLabel: t('templates.items.evolucaoSemanalTreino.form.week.energyLevel.minLabel'),
                            maxLabel: t('templates.items.evolucaoSemanalTreino.form.week.energyLevel.maxLabel'),
                            dotConfigs: [
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                                { iconKey: 'star' },
                            ],
                        },
                    },
                    {
                        order: 4,
                        type: 'text',
                        label: t('templates.items.evolucaoSemanalTreino.form.week.comments.label'),
                        description: null,
                        required: false,
                        settings: null,
                    },
                ],
            },
        ],
        actions: [],
    },
});

export default evolucaoSemanalTreino;
